import { render } from "./QuickReservation.vue?vue&type=template&id=238273b2&scoped=true&ts=true"
import script from "./QuickReservation.vue?vue&type=script&lang=ts"
export * from "./QuickReservation.vue?vue&type=script&lang=ts"

import "./QuickReservation.vue?vue&type=style&index=0&id=238273b2&lang=scss&scoped=true"
import "./QuickReservation.vue?vue&type=style&index=1&id=238273b2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238273b2"]])

export default __exports__